<div class="container">
	<div class="content">
		<form [formGroup]="addContactForm" (ngSubmit)="(addContactForm.valid)">
			<div class="flex-layout row space-between-center gap-sm">
				<mat-form-field appearance="outline" class="flex-item flex-1">
					<mat-label>{{ 'first_name' | translate }}</mat-label>
					<input #recipientsInput formControlName="firstName" matInput type="text" />
				</mat-form-field>
				<mat-form-field appearance="outline" class="flex-item flex-1">
					<mat-label>{{ 'last_name' | translate }}</mat-label>
					<input formControlName="lastName" matInput type="text" />
				</mat-form-field>
			</div>
			<mat-form-field appearance="outline">
				<mat-label>{{ 'company' | translate }}</mat-label>
				<input formControlName="company" matInput type="text" />
			</mat-form-field>
			<mat-form-field appearance="outline">
				<mat-label>{{ 'email' | translate }}</mat-label>
				<input formControlName="email" matInput type="email" />
				@if (addContactForm.get('email').hasError('pattern')) {
					<mat-error>
						{{ 'invalid_email' | translate }} {{ invalidEmail() | translate }}
					</mat-error>
				}
			</mat-form-field>
			<div class="flex-layout row space-between-center gap-sm">
				<mat-form-field
					appearance="outline"
					class="flex-item flex-1"
					style="flex-basis: 20%"
				>
					<mat-label>{{ 'country_code' | translate }}</mat-label>
					<input formControlName="countryCode" matInput type="text" />
				</mat-form-field>
				<mat-form-field appearance="outline" class="flex-item flex-1">
					<mat-label>{{ 'phone' | translate }}</mat-label>
					<input formControlName="phoneNumber" matInput type="text" />
					@if (addContactForm.get('phoneNumber').hasError('pattern')) {
						<mat-error>{{ invalidPhonenumber() | translate }}</mat-error>
					}
				</mat-form-field>
			</div>

			<div class="m-b-sxs">
				<cmms-locations-section
					[locationsInputList]="addContactForm.value?.location"
					(locationsChanged)="updateFormData('location', $event)"
					[isRequired]="false"
					[disableMultipleSelect]="true"
					[disableNestedSelection]="true"
				></cmms-locations-section>
			</div>
			<cmms-labels-section
				[labelsList]="initialLabel ?? []"
				(updatedLabelsList)="updateFormData('labels', $event.labels)"
			/>
		</form>
	</div>
	<div class="footer">
		<div class="left">
			<div class="description">
				<div class="info-box">
					<span class="white-box line-height">ESC</span>
					<button mat-button class="cancel-button" (click)="onCloseDialog()">
						{{ 'cancel' | translate }}
					</button>
				</div>
			</div>
		</div>
		<div class="right">
			<button
				mat-flat-button
				class="copy-button"
				(click)="handleClick()"
				[disabled]="!isDirty() || !addContactForm.valid"
			>
				<span>{{
					editContact() ? ('save_changes' | translate) : ('add_contact' | translate)
				}}</span>
			</button>
		</div>
	</div>
</div>
